import React from 'react'

import Image from '../../parts/image'
import Heading from '../../parts/heading'
import Markdown from '../../parts/markdown'

const AgeGateHeader = ({ data, type, locked }) => {
  let title = data.title ? data.title : null
  let text = data.text ? data.text : null
  let logo = data.logo ? data.logo : null

  // Display custom data when using the age gate within a video player
  if (type && (type === 'video' || type === 'modal') && data.video) {
    title = data.video.title ? data.video.title : (data.title ? data.title : null)
    text = data.video.text ? data.video.text : (data.text ? data.text : null)
    logo = data.video.logo ? data.video.logo : (data.video.logo === null ? null : (data.logo ? data.logo : null))
  }

  return (
    <>
      <div className="flex items-center flex-col">
        {logo !== null && (
          <Image
            media={logo}
            className={`age-gate-logo`}
          />
        )}
        {!locked && (
          <>
            {title !== null && (
              <Heading
                text={title}
                tag={'h2'}
                className="age-gate-title"
              />
            )}
            {text !== null && (
              <Markdown
                children={text}
                className="age-gate-subtitle"
              />
            )}
          </>
        )}
      </div>
      <div className="age-gate-decoration-left" />
      <div className="age-gate-decoration-right" />
      <div className="age-gate-decoration-background" />
    </>
  )
}

export default AgeGateHeader
